import { Text } from '@kanda-libs/ks-design-library';
import { Form } from '@kanda-libs/ks-component-ts';

import FormPage from 'pages/ApplyForFinance/FormPage';
import Header from './Header';
import Field from './Field';
import { PROPS, CLASS_NAMES, FIELDS } from './constants';
import useAcceptDisclaimerForm from './useAcceptDisclaimerForm';

const Disclaimer = ({}) => {
  const { form, nextButtonProps, isLoading, onSubmit } =
    useAcceptDisclaimerForm();
  const innerItemsProps = { isLoading };

  return (
    <Form id="disclaimer" form={form} onSubmit={onSubmit}>
      <FormPage nextButtonProps={nextButtonProps}>
        <Header />
        <Text {...PROPS.disclaimerTitle} {...innerItemsProps} />
        <div className={CLASS_NAMES.disclaimer}>
          <Text {...PROPS.disclaimer} {...innerItemsProps} />
        </div>
        {FIELDS.map((field) => (
          <Field key={field.fieldName} {...field} />
        ))}
      </FormPage>
    </Form>
  );
};

Disclaimer.displayName = 'ApplyForFinance-Desktop-Pages-Disclaimer';

export default Disclaimer;
